import styled from "styled-components"

import {
  Instagram,
  TwitterSquare,
  Linkedin,
  GithubSquare,
} from "styled-icons/fa-brands"

export const Container = styled.div`
  display: flex;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  @media only screen and (min-width: 480px) {
    br {
      display: none;
    }
  }
  img {
    border-radius: 10px;
  }
`

export const ImgWrapper = styled.div`
  margin-right: 1rem;
  margin-bottom: 0;
`
export const GithubIcon = styled(GithubSquare)`
  @media only screen and (min-width: 480px) {
    margin-left: 15px;
  }
  width: 25px;
  :hover {
    color: #24292e;
  }
`

export const InstagramIcon = styled(Instagram)`
  width: 25px;
  :hover {
    color: #d9317a;
  }
`

export const TwitterIcon = styled(TwitterSquare)`
  width: 25px;
  :hover {
    color: #1da1f2;
  }
`

export const LinkedinIcon = styled(Linkedin)`
  width: 25px;
  :hover {
    color: #2867b2;
  }
`
